<template>
	<div>
		<div style="text-align:center;"><span v-text="title"></span></div>
		<span v-if="items.length === 0" v-text="emptyTip"></span>
		<div v-else style="margin:10px 0px 0px 20px;">
			<el-tag style="margin: 0px 5px 5px 0px; cursor: pointer;" @close="remove(item)" v-for="item in items" :key="item._id.$oid" closable>
				{{ item.process.name }}
			</el-tag>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		props: {
			title: {
				type: String,
				required: true,
			},
			items: {
				type: Array,
			},
			emptyTip: {
				type: String,
			},
		},
		methods: {
			/**
			 * 删除。
			 */
			remove(row) {
				var techId = row.tech_id
				this.$emit('remove', { _id: { $oid: techId } })
			},
		},
	}
</script>

<style></style>
